import styled, { css } from 'styled-components';
import { noop } from 'lodash';

import { Atc } from '@dreryk/drerykweb-medicine-api';

import { appendTestableElementAttributes, basicBodyTextStyle, fonts, Tooltip } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { Anxiolytic } from './Anxiolytic/Anxiolytic';

type StyledMedicineItemNameProps = {
   $clickable: boolean;
   $valid: boolean;
};

const StyledMedicineItemName = styled.div<StyledMedicineItemNameProps>`
   ${basicBodyTextStyle}
   font-weight: ${fonts.fontWeightBold};

   ${(props) =>
      props.$clickable &&
      props.$valid &&
      css`
         color: ${props.theme.primary};
         cursor: pointer;
      `};

   ${(props) =>
      !props.$valid &&
      css`
         color: ${props.theme.disabledDark};
      `}
`;

StyledMedicineItemName.displayName = 'StyledMedicineItemName';

type MedicineNameProps = {
   readonly name: string;
   readonly atc: Atc;
   readonly onClick?: VoidFunction;
   readonly testId?: string;
   readonly valid?: boolean;
};

export const MedicineName = (props: MedicineNameProps): JSX.Element => {
   const testId = props.testId ?? 'medicineName';
   const valid = props.valid !== false;
   const clickable = Boolean(props.onClick) && valid;

   return (
      <Tooltip content={translationKeys.medicine.showMedicineDetails} testId={testId} disabled={!clickable}>
         <div onClick={clickable ? props.onClick : noop}>
            <StyledMedicineItemName
               as={clickable ? 'a' : 'span'}
               $clickable={clickable}
               $valid={valid}
               {...appendTestableElementAttributes(testId)}
            >
               {props.name}
            </StyledMedicineItemName>
            <Anxiolytic anxiolytic={props.atc} />
         </div>
      </Tooltip>
   );
};
